<template>
  <div class="usa-tax">
    <v-radio :disabled="disabled" :val="taxClasses.SIMPLIFIED_JOINT_STOCK" name="taxClassificationMX" v-model="localValue">Sociedad por Acciones Simplificada</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.SOCIETY_UNDER_COLLECTIVE_NAME" v-model="localValue">Sociedad en nombre colectivo</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.SIMPLE_LIMITED_PARTNERSHIP" v-model="localValue">Sociedad en comandita simple</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.LIMITED_LIABILITY_SOCIETY" v-model="localValue">Sociedad de responsabilidad limitada</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.ANONYMOUS_SOCIETY" v-model="localValue">Sociedad anónima</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.INVESTMENT_PROMOTER" v-model="localValue">Sociedad Anónima Promotora de Inversión</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.PUBLIC_LIMITED_COMPANY" v-model="localValue">Sociedad Anónima Bursátil</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.LIMITED_LIABILITY_COMPANY" v-model="localValue">Sociedad en comandita por acciones</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.COOPERATIVE" v-model="localValue">Sociedad cooperativa</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.CIVIL_SOCIETY" v-model="localValue">Sociedad civil</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.MULTIPURPOSE_FINANCIAL_COMPANY" v-model="localValue">Sociedad Financiera de Objeto Múltiple</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.FINANCIAL_COMPANY_LIMITED_LIABILITY" v-model="localValue">Sociedad Financiera de Objeto Limitada</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.OTHER" v-model="localValue">Otros</v-radio>
    <div class="usa-tax__error text-color-error" v-if="error">{{error}}</div>
  </div>
</template>

<script>
import vRadio from '@/ui/controls/vRadio'
// import vAutocomplete from '@/ui/controls/Autocomplete'

export default {
  data () {
    return {
      localValue: null
    }
  },

  components: {
    vRadio
    // vAutocomplete
  },

  computed: {
    taxClasses () {
      return {
        SIMPLIFIED_JOINT_STOCK: 'SIMPLIFIED_JOINT_STOCK',
        SOCIETY_UNDER_COLLECTIVE_NAME: 'SOCIETY_UNDER_COLLECTIVE_NAME',
        SIMPLE_LIMITED_PARTNERSHIP: 'SIMPLE_LIMITED_PARTNERSHIP',
        LIMITED_LIABILITY_SOCIETY: 'LIMITED_LIABILITY_SOCIETY',
        ANONYMOUS_SOCIETY: 'ANONYMOUS_SOCIETY',
        INVESTMENT_PROMOTER: 'INVESTMENT_PROMOTER',
        PUBLIC_LIMITED_COMPANY: 'PUBLIC_LIMITED_COMPANY',
        LIMITED_LIABILITY_COMPANY: 'LIMITED_LIABILITY_COMPANY',
        COOPERATIVE: 'COOPERATIVE',
        CIVIL_SOCIETY: 'CIVIL_SOCIETY',
        MULTIPURPOSE_FINANCIAL_COMPANY: 'MULTIPURPOSE_FINANCIAL_COMPANY',
        FINANCIAL_COMPANY_LIMITED_LIABILITY: 'FINANCIAL_COMPANY_LIMITED_LIABILITY',
        //
        OTHER: 'OTHER'
      }
    }
  },

  mounted () {
    this.localValue = this.value || this.taxClasses.SIMPLIFIED_JOINT_STOCK
  },

  props: {
    value: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: null
    }
  },

  watch: {
    value (val) {
      this.localValue = val
    },

    localValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>
